import React from 'react';
import { array } from 'prop-types';
import { Carousel } from 'antd';

import styles from './style.module.css';

function StoryImagesSlider({ images = [] }) {
  const onChange = (currentSlide) => {
    console.log(currentSlide);
  };
  const contentStyle = {
    margin: 0,
    height: '160px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: '#364d79',
  };
  return (
    <div key="imageSlider" className={styles.sliderContainer}>
      <Carousel afterChange={onChange}>
        {images.map((imgSrc, index) => (
          <div key={`ig-${index}`} style={contentStyle}>
            <img className={styles.imgSlider} src={imgSrc} alt={`story image ${index + 1}`} />
          </div>
        ))}
      </Carousel>
    </div>
  );
}

StoryImagesSlider.propTypes = {
  images: array,
};

export default StoryImagesSlider;
